const transfers = {
  transfer: "转移", // translated
  transfers: "接送服务", // translated
  dateAndTime: "日期和时间", // translated
  transferFrom: "从转移", // translated
  duration: "期间", // translated
  numOfPersons: "人数", // translated
  baggageAllowance: "行李限额", // translated
  small: "小的", // translated
  big: "大的", // translated
  provider: "提供者", // translated
  vehicle: "车辆", // translated
  distance: "距离", // translated
  price: "价格", // translated
  inboundJourney: "入境旅程", // translated
  outboundJourney: "出境游", // translated
  arrivalTime: "到达时间", // translated
  flightDetails: "航班详情", // translated
  inboundPickupDate: "入境取件日期", // translated
  outboundPickupDate: "出境取件日期", // translated
  travelInfo: "旅游信息", // translated
  flightsInfo: "航班信息", // translated
  airportYouAreFlyingFrom: "您起飞的机场", // translated
  airportYouAreFlyingTo: "您要飞往的机场", // translated
  inboundFlightNumber: "进港航班号", // translated
  outboundFlightNumber: "去程航班号", // translated
  inboundAirlineName: "入境航空公司名称", // translated
  outboundAirlineName: "出港航空公司名称", // translated
  tripMode: "行程模式", // translated
  airportToPoint: "机场至点", // translated
  pointToAirport: "指向机场", // translated
  roundTrip: "往返", // translated
  destinationPoint: "目的地点", // translated
  originPoint: "原点", // translated
  transferType: "传输类型", // translated
  min: "最小", // translated
  max: "最大限度", // translated
  pieces: "件", // translated
  cancelationIs: "取消是", // translated
};


export default transfers;
